import { PrimeVueDialogSymbol } from 'primevue/usedialog';
import DynamicDialogEventBus from 'primevue/dynamicdialogeventbus';
import { markRaw } from 'vue';

const CustomDialogService = {
    install: (app) => {
        const DialogService = {
            open: (content, options) => {
                // Wrap onClose to emit a custom event
                if (options && options.onClose) {
                    const originalOnClose = options.onClose;
                    options.onClose = (dialogOptions) => {
                        // Emit a custom event
                        document.dispatchEvent(new Event('dialog-closed'));
                        // Call the original onClose method
                        return originalOnClose(dialogOptions);
                    };
                } else if (options) {
                    // If no onClose method is provided, add one that emits the custom event
                    options.onClose = (dialogOptions) => {
                        document.dispatchEvent(new Event('dialog-closed'));
                    };
                }

                const instance = {
                    content: content && markRaw(content),
                    options: options || {},
                    data: options && options.data,
                    close: (params) => {
                        DynamicDialogEventBus.emit('close', { instance, params });
                    }
                };

                DynamicDialogEventBus.emit('open', { instance });

                return instance;
            }
        };

        app.config.globalProperties.$dialog = DialogService;
        app.provide(PrimeVueDialogSymbol, DialogService);
    }
};

export default CustomDialogService;
